export const kPostureTypes = ['sitting', 'supine', 'standing'] as const;
